// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Lhnr8","name":"Header_name__slxgR","subhead":"Header_subhead__Kf0J7","link":"Header_link__jrd00"};